import { useNavigation } from "@react-navigation/native";
import { useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { useTheme } from "../hooks/use-theme";
import MarkdownView from "./MarkdownView";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import ScreenTitle from "./ScreenTitle";
import IconButton from "./IconButton";

type SimpleHeaderProps = {
    title: string;
    descriptionMarkdown?: string;
    hideCloseButton?: boolean;
    onClose?: () => void;
    mode?: "large" | "small";
};

type ScreenParams = StackScreenProps<RootStackParamList>;

const SimpleHeader = ({
    title,
    descriptionMarkdown,
    hideCloseButton,
    onClose,
    mode = "large",
}: SimpleHeaderProps) => {
    const navigation = useNavigation<ScreenParams["navigation"]>();
    const styles = useStyles();

    return (
        <View style={styles.headerContainer}>
            <View style={styles.top}>
                <ScreenTitle style={styles.title} mode={mode}>
                    {title}
                </ScreenTitle>
                {!hideCloseButton && (
                    <IconButton
                        style={styles.closeButton}
                        icon="close"
                        size={36}
                        onPress={() => {
                            if (onClose) {
                                onClose();
                            } else if (navigation.canGoBack()) {
                                navigation.goBack();
                            } else {
                                navigation.popTo("Home", {
                                    screen: "MissionsScreen",
                                    params: { screen: "MissionList" },
                                });
                            }
                        }}
                    />
                )}
            </View>
            {descriptionMarkdown && (
                <MarkdownView style={styles.markdown} markdown={descriptionMarkdown} />
            )}
        </View>
    );
};

const useStyles = () => {
    const { gridSize, marginSize } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                headerContainer: {
                    paddingHorizontal: marginSize,
                    paddingVertical: marginSize,
                    display: "flex",
                    flexDirection: "column",
                },
                top: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                },
                title: {
                    flexGrow: 1,
                    flexShrink: 0,
                },
                markdown: {
                    display: "flex",
                },
                closeButton: {
                    flexGrow: 0,
                    flexShrink: 0,
                    width: 48,
                    height: 48,
                    margin: 0,
                    marginLeft: gridSize / 2,
                },
            }),
        [gridSize, marginSize],
    );
};

export default SimpleHeader;
